import React, { useEffect, useState } from "react";
import leftArrow from "../assets/icons/left-arrow.svg";
import UsdtIcon from "../assets/icons/usdt-icon.svg";
import { AllTicketsCount } from "../constants/const";
import MegaJackpotImage from "../assets/images/mega-jackpot-image.svg";
import DecrementIcon from "../assets/icons/decrement-icon.svg";
import IncrementIcon from "../assets/icons/increment-icon.svg";
import MainButton from "../components/MainButton";
import ButTicketIcon from "../assets/icons/buy-ticket-icon.svg";
import CompleteModal from "../components/CompleteModal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import Countdown from "react-countdown";
import Completionist from "../components/Completionist";
import { Spin } from "antd";
import {
    approveUSDT,
    buyMegaTickets,
    buyTickets,
    getMegaTicketsCount,
    getMegaTicketsPrice,
    getMegaTicketsSoldCount, getUserMegaTickets, megajackpotCircle,
    megaTicketsCount,
    megaTicketsCountLimit
} from "../web3";
import { ApiClient } from "../utils/ApiClient";

function MegaJackpot(data: any) {
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [inputValue, setInputValue] = useState(1);
    const [totalCount, setTotalCount] = useState<any>(1);
    const [loading, setLoading] = useState<any>(false);
    const [megaTicketsPrice, setMegaTicketsPrice] = useState<number>(0);
    const [megaTicketCount, setMegaTicketCount] = useState<any>("");
    const [megaTicketsSoldCount, setMegaTicketsSoldCount] = useState<any>("");
    const [megaCycle, setMegaCycle] = useState();

    const { t } = useTranslation();
    const navigate = useNavigate();

    const apiClientMega = new ApiClient("https://cryptolottery777.com/public/megajackpots/data");


    useEffect(() => {
        getMegaTicketsPrice().then(price => {
            setMegaTicketsPrice(Number(price));
            setTotalCount(price)

        });
        megajackpotCircle().then((res: any) => {
            setMegaCycle(res)
        })

    }, []);
    useEffect(() => {
        megaTicketsCountLimit().then(count => {
            console.log("Count", count);
            setMegaTicketCount(count)
        });
        megaTicketsCount().then(soldCount => {
            console.log("sold", soldCount);
            setMegaTicketsSoldCount(soldCount)
        })
    }, [infoModalOpen]);


    // Хелпер: обновить лимит и проданные, вернуть числа
    const refreshCounts = async () => {
        const [limitRaw, soldRaw] = await Promise.all([
            megaTicketsCountLimit(),
            megaTicketsCount(),
        ]);
        const limit = Number(limitRaw ?? 0);
        const sold = Number(soldRaw ?? 0);
        setMegaTicketCount(limit);
        setMegaTicketsSoldCount(sold);
        return { limit, sold };
    };


    const handleInputValue = (e: any) => {
        let inputCount: any = Number(e.target.value)
        if (inputCount <= megaTicketsCount && inputCount >= 0) {
            let totalPriceInUsdt = inputCount * megaTicketsPrice
            setInputValue(inputCount)
            setTotalCount(totalPriceInUsdt)
        }
    };

    const handleDecrement = () => {
        if (Number(inputValue) > 1) {
            let decrementValue: any = Number(inputValue) - 1;
            let totalPriceInUsdt = decrementValue * megaTicketsPrice
            setInputValue(decrementValue);
            setTotalCount(totalPriceInUsdt)
        }
    };
    const handleIncrement = () => {
        if (Number(inputValue) < megaTicketCount) {
            let incrementValue: any = Number(inputValue) + 1;
            let totalPriceInUsdt = incrementValue * megaTicketsPrice
            setInputValue(incrementValue);
            setTotalCount(totalPriceInUsdt)
        }
    };


    // const handleBuyMegaJackpotTicket = () => {
    //     setLoading(true)

    //     approveUSDT(totalCount, data?.provider).then(res => {

    //         if (res) {
    //             buyMegaTickets(inputValue, data?.provider).then(res => {

    //                 getUserMegaTickets(data?.address).then(res => {
    //                     const numArray = res[0]?.split(',')


    //                     var fetchMegaJackpotData: any = {
    //                         walletAddress: data?.address,
    //                         tickets: numArray,
    //                         ticketPrice: megaTicketsPrice,
    //                         cycle: megaCycle,
    //                     };


    //                     apiClientMega.post(fetchMegaJackpotData).then(res => {

    //                     });
    //                     if (res) {
    //                         setLoading(false)
    //                         setInfoModalOpen(true);
    //                     } else {
    //                         setLoading(false)
    //                         setIsError(true)
    //                         setInfoModalOpen(true);
    //                     }
    //                 });
    //                 // winningJackpotTicketsRewards()
    //             })
    //         } else {
    //             setLoading(false);
    //             setInputValue(1)
    //             setTotalCount(1)
    //             setIsError(true)
    //             setInfoModalOpen(true);
    //         }
    //     })
    // };


    const handleBuyMegaJackpotTicket = () => {
  setLoading(true);

  approveUSDT(totalCount, data?.provider).then((res) => {
    if (!res) {
      setLoading(false);
      setInputValue(1);
      setTotalCount(1);
      setIsError(true);
      setInfoModalOpen(true);
      return;
    }

    buyMegaTickets(inputValue, data?.provider).then(async (buyRes) => {
      try {
        // подтягиваем ваши билеты и отправляем на бэкенд (как было)
        const userTickets = await getUserMegaTickets(data?.address);
        const numArray = userTickets?.[0]?.split(',') ?? [];

        const fetchMegaJackpotData: any = {
          walletAddress: data?.address,
          tickets: numArray,
          ticketPrice: megaTicketsPrice,
          cycle: megaCycle,
        };

        // отправка на бэкенд — без блокировки UX
        apiClientMega.post(fetchMegaJackpotData).catch(() => {});

        // 🔄 ОБНОВЛЯЕМ СЧЁТЧИКИ после покупки
        const { limit, sold } = await refreshCounts();

        // ✅ ПРОВЕРКА: если все билеты распроданы — на главную
        if (limit > 0 && sold >= limit) {
          setLoading(false);
          // можно не показывать модалку завершения, сразу уходим
          navigate('/');
          return;
        }

        // иначе — обычный флоу успеха
        if (buyRes) {
          setLoading(false);
          setIsError(false);
          setInfoModalOpen(true);
        } else {
          setLoading(false);
          setIsError(true);
          setInfoModalOpen(true);
        }
      } catch (e) {
        console.error(e);
        setLoading(false);
        setIsError(true);
        setInfoModalOpen(true);
      }
    }).catch((e) => {
      console.error(e);
      setLoading(false);
      setIsError(true);
      setInfoModalOpen(true);
    });
  }).catch((e) => {
    console.error(e);
    setLoading(false);
    setIsError(true);
    setInfoModalOpen(true);
  });
};


    return (

        <>
            {loading ? <Spin fullscreen={true} size="large" /> :
                <div className="jackpot">
                    <div className="jackpot_title">
                        <img src={leftArrow} alt="icon" width={32} height={32} onClick={() => {
                            navigate('/')
                        }} />
                        <span>{t('Мега Джекпот')}</span>
                    </div>
                    <div className="mega-jackpot_info">
                        <div className="mega-jackpot_info__price ">
                            <img src={UsdtIcon} alt="icon" />
                            <span className="mega-jackpot_info__price___unit-price">{megaTicketsPrice} USDT</span>
                            <span className="mega-jackpot_info__price___text">{t('за билет')}</span>
                        </div>
                        <div className="jackpot_info__tickets-count">
                            <div className="jackpot_info__tickets-count___item">
                                <div className="jackpot_info__tickets-count___item____title">{t('Всего билетов')}</div>
                                <div className="jackpot_info__tickets-count___item____count">{megaTicketCount}</div>
                            </div>
                            <div className="jackpot_info__tickets-count___item">
                                <div className="jackpot_info__tickets-count___item____title">{t('Доступный')}</div>
                                <div
                                    className="jackpot_info__tickets-count___item____count">{megaTicketCount - megaTicketsSoldCount}</div>
                            </div>
                            <div className="jackpot_info__tickets-count___item">
                                <div className="jackpot_info__tickets-count___item____title">{t('Проданный')}</div>
                                <div className="jackpot_info__tickets-count___item____count">{megaTicketsSoldCount}</div>
                            </div>
                        </div>

                        <img src={MegaJackpotImage} alt="icon" className="mega-jackpot_info__logo" />
                    </div>
                    <div className="buy-ticket-block">
                        <div className="buy-ticket-block_header">
                            <div className="buy-ticket-block_header__title">
                                {t('Количество билетов')}
                            </div>
                            <div className="buy-ticket-block_header__subtitle">
                                {t('Вы можете выбрать количество билетов с номерами, которые будут присвоены случайным образом.')}
                            </div>
                        </div>
                        <div className="ticket-count-input">
                            <img src={DecrementIcon} alt="icon" onClick={handleDecrement} />
                            <input
                                type="text"
                                className="ticket-count-input_count"
                                value={inputValue}
                                onChange={handleInputValue}
                            />
                            <img src={IncrementIcon} alt="icon" onClick={handleIncrement} />
                        </div>
                        <div className="buy-ticket-block_btn">
                            <MainButton
                                icon={ButTicketIcon}
                                text={'Купить билет за'}
                                price={totalCount}
                                func={handleBuyMegaJackpotTicket}
                            />
                        </div>
                    </div>

                    <CompleteModal
                        infoModalOpen={infoModalOpen}
                        setInfoModalOpen={setInfoModalOpen}
                        isError={isError}
                    />

                </div>}
        </>
    )
}

export default MegaJackpot
